/**
 * StatusDot — Glowing status indicator.
 */

interface StatusDotProps {
  status: "online" | "offline" | "warning" | "error";
  size?: "sm" | "md" | "lg";
  pulse?: boolean;
  label?: string;
}

export function StatusDot({
  status,
  size = "md",
  pulse = true,
  label,
}: StatusDotProps) {
  const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  const statusClasses = {
    online: "bg-[var(--bw-success)]",
    offline: "bg-[var(--bw-muted)]",
    warning: "bg-[var(--bw-warn)]",
    error: "bg-[var(--bw-danger)]",
  };

  const glowClasses = {
    online: "shadow-[0_0_8px_var(--bw-success)]",
    offline: "",
    warning: "shadow-[0_0_8px_var(--bw-warn)]",
    error: "shadow-[0_0_8px_var(--bw-danger)]",
  };

  return (
    <span className="inline-flex items-center gap-2">
      <span
        className={`
          ${sizeClasses[size]}
          ${statusClasses[status]}
          ${glowClasses[status]}
          rounded-full
          ${pulse && status !== "offline" ? "animate-pulse" : ""}
        `}
      />
      {label && (
        <span className="text-sm text-[var(--bw-fg)]">{label}</span>
      )}
    </span>
  );
}
